//
import Service from '@/services/api/service'
import SalarySettlementModel from '@/models/HumanResource/HrSalarySettlement'
import MassiveAssetDiscountModel from '@/models/HumanResource/MassiveAssetDiscount'

//
import fetchByPeriod from './fetchByPeriod'
import generateMassiveSalaries from './generateMassiveSalaries'
import print from './print'

//
export default class extends Service {

    //
    static includes = [
        'hr_asset_discounts',
        'hr_employee.hr_family_burdens',
        'hr_employee.hr_isapre_plans.hr_isapre_type',
        'hr_employee.hr_isapre_plan_active.hr_isapre_type',
        'hr_contract.hr_contract_type',
        'hr_contract.hr_contract_period',
        'hr_prevision',
        'hr_health_affiliation',
        'hr_indicator',
        'g_user.hr_employee',
        'g_confirmer_user.hr_employee',
        'hr_salary_settlementisapre_plan.hr_isapre_type',
    ]
    
    //
    static model = SalarySettlementModel

    /**
     * 
     * @param {*} data 
     */
    static async assignMassiveDiscounts ( data ) {

        //
        const Model = MassiveAssetDiscountModel

        //
        try {

            //
            const newModel = new Model( data )
                , response = await newModel.save()
            
            //
            return response
        } catch ( error ) {

            //
            return error.response.data
        }
    }

    /**
     * 
     * @param {*} id 
     */
    static async confirm ( id ) {

        //
        const Model = this.model

        //
        try {

            //
            const currModel = new Model({ id })
                , response = await currModel.confirm().attach({})
            
            //
            return response.data
        } catch ( error ) {

            //
            return error.response.data
        }
    }

    //
    static fetchByPeriod            = fetchByPeriod
    static generateMassiveSalaries  = generateMassiveSalaries
    static print                    = print
}
